import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { DemoModeProvider } from "@/hooks/use-demo-mode";
import { AuthProvider } from "@/hooks/use-auth";
import { Toaster } from "@/components/ui/sonner";
import "./styles.css";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a client-side router
const router = createRouter({ routeTree });

// Register router for type inference
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Create query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

// Log that the app is loading
if (typeof window !== "undefined") {
  console.log("[FlightDeck] App starting", new Date().toISOString());
}

// Render the app
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <DemoModeProvider>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </DemoModeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
